var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('VirtualTable',{attrs:{"values":{
      playerList:_vm.playerList,
      competitions:_vm.competitions,
      tableData:_vm.tableData,
      currentTeam:_vm.currentTeam,
      maxQ:_vm.maxNum}}}),_c('ScoreCompare')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }